import { Fragment, useState } from "react";
import { Link } from "react-router-dom";

import classes from "./MainNavigation.module.css";

import MainHeader from "../MainHeader/MainHeader";
import NavLinks from "../NavLinks/NavLinks";
import SideDrawer from "../SideDrawer/SideDrawer";
import Backdrop from "../../Backdrop/Backdrop";
import HeaderCartButton from "../CartButton/HeaderCartButton";

import useWindowDimensions from "../../../hooks/useWindowDimensions";

// main navigation bar at top of every page 
const MainNavigation = (props) => {
  const [drawerIsOpen, setDrawerIsOpen] = useState(false); // toggle side drawer

  const { width } = useWindowDimensions();

  const menuURL = process.env.REACT_APP_ASSETS_URL + "/assets/icons/menu_icon.svg"

  const openDrawerHandler = () => {
    setDrawerIsOpen(true);
  };

  const closeDrawerHandler = () => {
    setDrawerIsOpen(false);
  };

  return (
    <Fragment>
      {drawerIsOpen && <Backdrop onClose={closeDrawerHandler} />}
      <SideDrawer show={drawerIsOpen} onClick={closeDrawerHandler}>
        <nav className={classes.main_navigation__drawer_nav}>
          <NavLinks />
        </nav>
      </SideDrawer>
      <MainHeader>
        <div className={classes.left_section}>
          <nav className={classes.main_navigation__header_nav}>
            <NavLinks />
          </nav>
          <img
            src = {menuURL}
            alt="new"
            className={classes.main__navigation_menu__btn}
            onClick={openDrawerHandler}
            height="70"
          />
        </div>
        <div className={classes.middle_section}>
          <h1 className={classes.main_navigation__title}>
            {width>800 ? <Link to="/home" >Backroom Bar Bible</Link> : <Link to="/home">B.B.B</Link>}
          </h1>
        </div>
        <div className={classes.right_section}>
          <HeaderCartButton showCart={props.showCart} />
        </div>
      </MainHeader>
    </Fragment>
  );
};

export default MainNavigation;
